import React from 'react'

const EditProject = () => {
  return (
    <div>
      <h3>Edit Project</h3>
    </div>
  )
}

export default EditProject
